/**
 * 大屏模块（src/views/bigScreen，第 1 组：排序后第 1~21 个文件）英文映射
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 * 覆盖文件：
 *  AnnualAccountsReceivable / InspectionAbnormalCondition / InspectionAndMaintenance /
 *  InspectionCenter / InspectionCompletedMonth / InspectionDynamics / InspectionMaintenanceCompleted /
 *  InspectionPeriod / InspectionRegionalRanking / InspectionTaskMonth / KeyAreasAndAbnormalPressure /
 *  MaintenancePeriod / MeterCommunityRate / MeterManufacturerTotal / MeterReadingAmountOfWater /
 *  MeterReadingCenter / MeterReadingIndex / MeterReadingLargeUsers / MeterReadingOnlineAndFault /
 *  MeterReadingSizeMeterNumAndOnline / MeterRealTimeAlarmList
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js / 其他 en/modules/*.js）──
  '确定': 'OK',
  '取消': 'Cancel',
  '关闭': 'Close',
  '是': 'Yes',
  '否': 'No',
  '其他': 'Other',

  // ── 面板标题 / 表头 / 通用列 ──
  '序号': 'No.',
  '名称': 'Name',
  '类型': 'Type',
  '时间': 'Time',
  '状态': 'Status',
  '暂无数据': 'No Data',
  '本年': 'This Year',
  '去年': 'Last Year',
  '今年': 'This Year',
  '本月任务': 'Tasks This Month',

  // ── 年应收（AnnualAccountsReceivable）──
  '年应收': 'Annual Receivable',
  '应收': 'Receivable',
  '实收': 'Actual Revenue',
  '收费(元)': 'Charges (CNY)',
  '本年应收：{a}元  本年实收：{b}元': 'Current year receivable: {a} CNY  Current year received: {b} CNY',
  '去年应收：{a}元  去年实收：{b}元': 'Last year receivable: {a} CNY  Last year received: {b} CNY',

  // ── 最近30天异常情况（InspectionAbnormalCondition）──
  '最近30天异常情况': 'Abnormalities in the Last 30 Days',
  '故障设备排名': 'Faulty Device Ranking',
  '故障隐患趋势': 'Fault Hazard Trend',
  '故障设备分布': 'Faulty Device Distribution',
  '实际巡检': 'Actual Inspections',

  // ── 巡检维保统计（InspectionAndMaintenance）──
  '巡检维保统计': 'Inspection & Maintenance Statistics',
  '累计巡检公里': 'Cumulative Inspection Kilometers',
  '累计保养次数': 'Cumulative Maintenance Times',

  // ── 巡检概览（InspectionCenter）──
  '环比': 'MoM',
  '当日巡检任务数': 'Today\'s Inspection Tasks',
  '当日未巡检任务数': 'Today\'s Uninspected Tasks',
  '当日即将过期任务数': 'Tasks Expiring Today',
  '计划巡检': 'Planned Inspections',
  '计划保养': 'Planned Maintenance',

  // ── 巡检本月完成指标（InspectionCompletedMonth）──
  '本月完成指标': 'Monthly Completion KPI',
  '已完成': 'Completed',

  // ── 巡检动态（InspectionDynamics）──
  '巡检动态': 'Inspection Dynamics',
  '临时任务': 'Temporary Task',
  '日常任务': 'Routine Task',
  '未分配': 'Unassigned',
  '已分配': 'Assigned',
  '结束': 'Finished',

  // ── 巡检维保完成率（InspectionMaintenanceCompleted）──
  '巡检保养完成率': 'Inspection & Maintenance Completion Rate',
  '实际保养': 'Actual Maintenance',
  '综合完结率(%)': 'Overall Completion Rate (%)',

  // ── 单位 ──
  '单位:个': 'Unit: Count',
  '单位:次': 'Unit: Times',
  '单位:%': 'Unit: %',

  // ── 巡检/保养同期对比（InspectionPeriod / MaintenancePeriod）──
  '巡检同期对比': 'Inspection YoY Comparison',
  '保养同期对比': 'Maintenance YoY Comparison',

  // ── 本月各区域排名（InspectionRegionalRanking）──
  '本月各区域排名': 'Area Ranking This Month',
  '区域名称': 'Area Name',
  '完成情况': 'Completion',

  // ── 本月巡检任务（InspectionTaskMonth）──
  '本月巡检任务': 'Monthly Inspection Tasks',

  // ── 重点部位压力（KeyAreasAndAbnormalPressure）──
  '重点部位压力': 'Key Areas Pressure',
  '主管道': 'Main Pipeline',
  '支管道': 'Branch Pipeline',
  '管网名称': 'Pipe Network Name',
  '实时压力': 'Real-time Pressure',
  '实时流量': 'Real-time Flow',

  // ── 小区远传表近7日抄见率（MeterCommunityRate）──
  '小区远传表近7日抄见率': 'Community Remote Meter Reading Rate (Last 7 Days)',
  '小区名称': 'Community Name',
  '抄见时间': 'Meter Reading Time',
  '小区户数': 'Households',
  '抄见户数': 'Metered Households',
  '抄见率': 'Meter Reading Rate',

  // ── 水表厂家情况汇总（MeterManufacturerTotal）──
  '水表厂家情况汇总': 'Water Meter Manufacturer Summary',
  '厂家名称': 'Manufacturer Name',
  '水表总数': 'Total Meters',
  '远传/非远传': 'Remote/Non-remote',
  '传输方式': 'Transmission Type',
  '远传': 'Remote',

  // ── 水量统计（MeterReadingAmountOfWater）──
  '水量统计(近一月)': 'Water Volume Statistics (Last Month)',
  '水量': 'Water Volume',
  '水量(万吨)': 'Water Volume (10k tons)',
  '周一': 'Mon',
  '周二': 'Tue',
  '周三': 'Wed',
  '周四': 'Thu',
  '周五': 'Fri',
  '周六': 'Sat',
  '周日': 'Sun',

  // ── 抄表指标（MeterReadingIndex / MeterReadingCenter / MeterReadingLargeUsers）──
  '抄表指标(近一周)': 'Meter Reading Indicators (Last 7 Days)',
  '大用户抄表(近一周)': 'Large Customer Meter Reading (Last 7 Days)',
  '本月总用水量(万吨)': 'Monthly Total Water Use (10k tons)',
  '抄表率(%)': 'Meter Reading Rate (%)',
  '应抄': 'Scheduled Reading',
  '实抄': 'Actual Reading',
  '抄表率': 'Meter Reading Rate',
  '抄表(万户)': 'Meter Reading (10k households)',

  // ── 水表在线率/故障率（MeterReadingOnlineAndFault）──
  '水表在线率/故障率': 'Water Meter Online Rate / Fault Rate',
  '数量': 'Quantity',
  '数量(个)': 'Quantity (pcs)',
  '故障率': 'Fault Rate',
  '故障率(%)': 'Fault Rate (%)',

  // ── 表口径数量/在线率（MeterReadingSizeMeterNumAndOnline）──
  '表口径数量/在线率': 'Meter Caliber Count / Online Rate',
  '在线率(%)': 'Online Rate (%)',

  // ── 水表实时告警（MeterRealTimeAlarmList）──
  '水表实时告警': 'Real-time Meter Alarms',
  '表编号': 'Meter No.',
  '表类型': 'Meter Type',
  '故障类型': 'Fault Type',
  '告警时间': 'Alarm Time',
}
